import { render, staticRenderFns } from "./WidgetReviewsSquareGalleryPc.vue?vue&type=template&id=52a899d5"
import script from "./WidgetReviewsSquareGalleryPc.vue?vue&type=script&lang=js"
export * from "./WidgetReviewsSquareGalleryPc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports